/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../../../../gen/eigen_lcm/Vector3d";

export const protobufPackage = "skills";

export interface SpoofDroneRequest {
  /**
   * Position of the other drone relative to the current drone position at the start of the action
   * (in NAV)
   */
  relativePosition:
    | Vector3dPb
    | undefined;
  /** True if this drone is no longer active due to landing */
  isInactive: boolean;
  /** Lower urgency drones yield to higher urgency drones */
  urgency: number;
  /**
   * Last four characters of vehicle serial number. Can be obtained with, e.g.:
   *   cc_multi_drone.pack_skydio_serial_to_fixed32("SkydioX10-abcd")
   */
  sender: number;
  xyInaccuracy: number;
  zInaccuracy: number;
  /**
   * Deprecated fields, do not use.
   *
   * @deprecated
   */
  senderId: string;
  /** @deprecated */
  urgencyScore: number;
  /**
   * [m]
   *
   * @deprecated
   */
  radius: number;
}

export interface SpoofMultiDroneActionArgs {
  /**
   * How long to spoof the message for. If you want to spoof drones while executing another
   * action, you may need to use a parallel action.
   */
  durationS: number;
  spoofedDrones: SpoofDroneRequest[];
}

export interface SpoofMultiDroneResultData {
}

export interface SpoofMultiDroneActionStateData {
}

function createBaseSpoofDroneRequest(): SpoofDroneRequest {
  return {
    relativePosition: undefined,
    isInactive: false,
    urgency: 0,
    sender: 0,
    xyInaccuracy: 0,
    zInaccuracy: 0,
    senderId: "",
    urgencyScore: 0,
    radius: 0,
  };
}

export const SpoofDroneRequest = {
  encode(message: SpoofDroneRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.relativePosition !== undefined) {
      Vector3dPb.encode(message.relativePosition, writer.uint32(10).fork()).ldelim();
    }
    if (message.isInactive === true) {
      writer.uint32(32).bool(message.isInactive);
    }
    if (message.urgency !== 0) {
      writer.uint32(48).uint32(message.urgency);
    }
    if (message.sender !== 0) {
      writer.uint32(61).fixed32(message.sender);
    }
    if (message.xyInaccuracy !== 0) {
      writer.uint32(64).uint32(message.xyInaccuracy);
    }
    if (message.zInaccuracy !== 0) {
      writer.uint32(72).uint32(message.zInaccuracy);
    }
    if (message.senderId !== "") {
      writer.uint32(42).string(message.senderId);
    }
    if (message.urgencyScore !== 0) {
      writer.uint32(29).float(message.urgencyScore);
    }
    if (message.radius !== 0) {
      writer.uint32(21).float(message.radius);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofDroneRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofDroneRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.relativePosition = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isInactive = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.urgency = reader.uint32();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.sender = reader.fixed32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.xyInaccuracy = reader.uint32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.zInaccuracy = reader.uint32();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.senderId = reader.string();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.urgencyScore = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.radius = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofDroneRequest {
    return {
      relativePosition: isSet(object.relativePosition) ? Vector3dPb.fromJSON(object.relativePosition) : undefined,
      isInactive: isSet(object.isInactive) ? globalThis.Boolean(object.isInactive) : false,
      urgency: isSet(object.urgency) ? globalThis.Number(object.urgency) : 0,
      sender: isSet(object.sender) ? globalThis.Number(object.sender) : 0,
      xyInaccuracy: isSet(object.xyInaccuracy) ? globalThis.Number(object.xyInaccuracy) : 0,
      zInaccuracy: isSet(object.zInaccuracy) ? globalThis.Number(object.zInaccuracy) : 0,
      senderId: isSet(object.senderId) ? globalThis.String(object.senderId) : "",
      urgencyScore: isSet(object.urgencyScore) ? globalThis.Number(object.urgencyScore) : 0,
      radius: isSet(object.radius) ? globalThis.Number(object.radius) : 0,
    };
  },

  toJSON(message: SpoofDroneRequest): unknown {
    const obj: any = {};
    if (message.relativePosition !== undefined) {
      obj.relativePosition = Vector3dPb.toJSON(message.relativePosition);
    }
    if (message.isInactive === true) {
      obj.isInactive = message.isInactive;
    }
    if (message.urgency !== 0) {
      obj.urgency = Math.round(message.urgency);
    }
    if (message.sender !== 0) {
      obj.sender = Math.round(message.sender);
    }
    if (message.xyInaccuracy !== 0) {
      obj.xyInaccuracy = Math.round(message.xyInaccuracy);
    }
    if (message.zInaccuracy !== 0) {
      obj.zInaccuracy = Math.round(message.zInaccuracy);
    }
    if (message.senderId !== "") {
      obj.senderId = message.senderId;
    }
    if (message.urgencyScore !== 0) {
      obj.urgencyScore = message.urgencyScore;
    }
    if (message.radius !== 0) {
      obj.radius = message.radius;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofDroneRequest>, I>>(base?: I): SpoofDroneRequest {
    return SpoofDroneRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofDroneRequest>, I>>(object: I): SpoofDroneRequest {
    const message = createBaseSpoofDroneRequest();
    message.relativePosition = (object.relativePosition !== undefined && object.relativePosition !== null)
      ? Vector3dPb.fromPartial(object.relativePosition)
      : undefined;
    message.isInactive = object.isInactive ?? false;
    message.urgency = object.urgency ?? 0;
    message.sender = object.sender ?? 0;
    message.xyInaccuracy = object.xyInaccuracy ?? 0;
    message.zInaccuracy = object.zInaccuracy ?? 0;
    message.senderId = object.senderId ?? "";
    message.urgencyScore = object.urgencyScore ?? 0;
    message.radius = object.radius ?? 0;
    return message;
  },
};

function createBaseSpoofMultiDroneActionArgs(): SpoofMultiDroneActionArgs {
  return { durationS: 0, spoofedDrones: [] };
}

export const SpoofMultiDroneActionArgs = {
  encode(message: SpoofMultiDroneActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.durationS !== 0) {
      writer.uint32(13).float(message.durationS);
    }
    for (const v of message.spoofedDrones) {
      SpoofDroneRequest.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofMultiDroneActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofMultiDroneActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.durationS = reader.float();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.spoofedDrones.push(SpoofDroneRequest.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofMultiDroneActionArgs {
    return {
      durationS: isSet(object.durationS) ? globalThis.Number(object.durationS) : 0,
      spoofedDrones: globalThis.Array.isArray(object?.spoofedDrones)
        ? object.spoofedDrones.map((e: any) => SpoofDroneRequest.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SpoofMultiDroneActionArgs): unknown {
    const obj: any = {};
    if (message.durationS !== 0) {
      obj.durationS = message.durationS;
    }
    if (message.spoofedDrones?.length) {
      obj.spoofedDrones = message.spoofedDrones.map((e) => SpoofDroneRequest.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofMultiDroneActionArgs>, I>>(base?: I): SpoofMultiDroneActionArgs {
    return SpoofMultiDroneActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofMultiDroneActionArgs>, I>>(object: I): SpoofMultiDroneActionArgs {
    const message = createBaseSpoofMultiDroneActionArgs();
    message.durationS = object.durationS ?? 0;
    message.spoofedDrones = object.spoofedDrones?.map((e) => SpoofDroneRequest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSpoofMultiDroneResultData(): SpoofMultiDroneResultData {
  return {};
}

export const SpoofMultiDroneResultData = {
  encode(_: SpoofMultiDroneResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofMultiDroneResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofMultiDroneResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofMultiDroneResultData {
    return {};
  },

  toJSON(_: SpoofMultiDroneResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofMultiDroneResultData>, I>>(base?: I): SpoofMultiDroneResultData {
    return SpoofMultiDroneResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofMultiDroneResultData>, I>>(_: I): SpoofMultiDroneResultData {
    const message = createBaseSpoofMultiDroneResultData();
    return message;
  },
};

function createBaseSpoofMultiDroneActionStateData(): SpoofMultiDroneActionStateData {
  return {};
}

export const SpoofMultiDroneActionStateData = {
  encode(_: SpoofMultiDroneActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofMultiDroneActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofMultiDroneActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofMultiDroneActionStateData {
    return {};
  },

  toJSON(_: SpoofMultiDroneActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofMultiDroneActionStateData>, I>>(base?: I): SpoofMultiDroneActionStateData {
    return SpoofMultiDroneActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofMultiDroneActionStateData>, I>>(_: I): SpoofMultiDroneActionStateData {
    const message = createBaseSpoofMultiDroneActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
